export const MIN_HEIGHT_IN_CM_UNTIL_BACKEND_DATA_HAS_ARRIVED = 0;
export const MAX_HEIGHT_IN_CM_UNTIL_BACKEND_DATA_HAS_ARRIVED = 300;

export const MIN_WEIGHT_IN_KG_UNTIL_BACKEND_DATA_HAS_ARRIVED = 0;
export const MAX_WEIGHT_IN_KG_UNTIL_BACKEND_DATA_HAS_ARRIVED = 600;
